import { makeStyles } from '@rbx/ui';

const useChipsStyles = makeStyles()(() => ({
  inlineBlock: {
    display: 'inline-block',
  },

  chip: {
    fontSize: 16,
    fontWeight: 300,
    overflow: 'visible',
    '& *': {
      overflow: 'visible',
    },
  },

  chipContainer: {
    gap: 8,
  },
}));

export default useChipsStyles;
